export default __webpack_public_path__ + "static/media/sitting-man.084395ba.jpeg";